module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "us-states"
    }
  }, [_c('b-input-group', {
    attrs: {
      "id": "state-abbrev-input-group"
    }
  }, [_c('b-input-group-prepend', [_c('b-dropdown', {
    attrs: {
      "text": _vm.choice.abbr || 'Abbreviation',
      "no-flip": "",
      "boundary": "state-abbrev-input-group"
    }
  }, [_c('div', {
    attrs: {
      "form-class": "abbrDropdown bd-links"
    }
  }, _vm._l((_vm.states.states), function(state) {
    return _c('b-dropdown-item', {
      key: state['abbr'],
      on: {
        "click": function($event) {
          _vm.choice = state;
        }
      }
    }, [_vm._v(_vm._s(state['abbr']))])
  }), 1)])], 1), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "required": "",
      "id": "state-abbrev-input"
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  })], 1), _vm._v(" "), (_vm.showDropdown) ? _c('ul', {
    ref: "dropdown",
    attrs: {
      "id": "input-dropdown"
    }
  }, _vm._l((_vm.suggestions), function(item) {
    return _c('li', {
      staticClass: "suggestion",
      on: {
        "click": function($event) {
          _vm.choice = item
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c4f9ea8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup/UsStates.vue
// module id = 1306
// module chunks = 16